import type { IxcCasesV1CaseKeys } from '@interxfi/types';
import { type EntityPathBuilder, getResolvedPath } from '../../util/routing/entity-paths';

export const CASE_MANAGEMENT_CASE_BASE_PATH = getResolvedPath('/inbox', {});

export const getCaseManagementCasePath: EntityPathBuilder<IxcCasesV1CaseKeys> = (context) => {
  switch (context.kind) {
    case 'list':
      return CASE_MANAGEMENT_CASE_BASE_PATH;
    case 'detail': {
      // if (!context?.keys?.caseId) {
      //   return undefined;
      // }

      return CASE_MANAGEMENT_CASE_BASE_PATH;
    }
  }
};
